module.exports = __webpack_public_path__ + "media/metronic/_theme/media/illustrations/working-2c6048aae2db3b235a918f1427195773.svg";